var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { USER_TYPE } from '../../constants/userConstants';
import getUserType from '../../utils/proxy-util/getUserType';
import isSns from '../../utils/proxy-util/isSns';
/**
 * QR로그인 시 요청하여 얻은 응답결과를 TvingUser로 변환합니다.
 * @param otpResultUserBody
 */
var proxyOtpResultUser = function (otpResultUserBody) {
    var _a;
    var code = otpResultUserBody.code, message = otpResultUserBody.message, data = otpResultUserBody.data;
    var _b = data || {}, custNo = _b.custNo, userId = _b.custId, tvingToken = _b.tvingToken, authToken = _b.authToken, accessToken = _b.accessToken, refreshToken = _b.refreshToken, userTypeValue = _b.custType, cjOneMembershipYn = _b.cjOneMembershipYn, email = _b.email, lastPasswordUpdateDate = _b.lastPasswordUpdateDate, realNameConfirmYn = _b.realNameConfirmYn, regionCode = _b.regionCode, reqType = _b.reqType;
    var userNo = custNo === null || custNo === void 0 ? void 0 : custNo.toString();
    var userType = userTypeValue ? getUserType(userTypeValue, cjOneMembershipYn === 'Y') : USER_TYPE.TVING;
    var emailAddress;
    var emailVendor;
    if (email) {
        _a = __read(email.split('@'), 2), emailAddress = _a[0], emailVendor = _a[1];
    }
    return {
        userToken: tvingToken,
        authToken: authToken,
        accessToken: accessToken,
        refreshToken: refreshToken,
        userNo: userNo,
        userId: userId,
        isSns: isSns(userType),
        emailAddress: emailAddress,
        emailVendor: emailVendor,
        lastPasswordUpdateDate: lastPasswordUpdateDate,
        isRealNameConfirmed: realNameConfirmYn === 'Y',
        userType: userType,
        message: message,
        code: code,
        reqType: reqType,
        regionCode: regionCode,
    };
};
export default proxyOtpResultUser;
